// src/pages/admin/logs/components/LogTableFilters.js
import React from 'react';
import { Card, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { Search } from 'lucide-react';

const LogTableFilters = ({ activeTab, search, setSearch, filterLevel, setFilterLevel }) => {
    return (
        <Card.Body className="p-4 bg-transparent activity-logs-border-bottom">
            <Row className="g-3">
                <Col lg={8} md={6}>
                    <InputGroup className="border-0 rounded-3 activity-logs-input-group">
                        <InputGroup.Text className="bg-transparent border-0 text-secondary">
                            <Search size={18} />
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            placeholder={activeTab === 'system' ? "Search by Component, Message, IP..." : "Search by User, Role, Action Type..."}
                            className="bg-transparent border-0 shadow-none ps-0 activity-logs-input text-white"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </InputGroup>
                </Col>
                <Col lg={4} md={6}>
                    <Form.Select 
                        className="border-0 rounded-3 text-white py-2 activity-logs-select" 
                        value={filterLevel} 
                        onChange={(e) => setFilterLevel(e.target.value)}
                    >
                        <option value="All" style={{ backgroundColor: '#151521' }}>All Events</option>
                        {activeTab === 'system' ? (
                            <>
                                <option value="INFO" style={{ backgroundColor: '#151521' }}>INFO</option>
                                <option value="WARN" style={{ backgroundColor: '#151521' }}>WARN</option>
                                <option value="ERROR" style={{ backgroundColor: '#151521' }}>ERROR</option>
                            </>
                        ) : (
                            <>
                                <option value="LOGIN_SUCCESS" style={{ backgroundColor: '#151521' }}>Login Success</option>
                                <option value="LOGIN_FAILED" style={{ backgroundColor: '#151521' }}>Login Failed</option>
                                <option value="AUDITION_APPLIED" style={{ backgroundColor: '#151521' }}>Audition Applied</option>
                                <option value="SETTLEMENT_PROCESSED" style={{ backgroundColor: '#151521' }}>Settlements</option>
                            </>
                        )}
                    </Form.Select>
                </Col>
            </Row>
        </Card.Body>
    );
};

export default LogTableFilters;
